let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9bJRP")).then(() => parcelRequire('l2ERc'));